module.exports = __webpack_public_path__ + "images/img-1BhawCJ.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/shared/assets/img/noimage.png
// module id = 2264
// module chunks = 0